import React from 'react';

const QuestionMgrPage = () => {
  return <div>QuestionMgrPage</div>;
};

export default QuestionMgrPage;
